import { ExecYearmonthState } from "./types";
import { Module } from "vuex";
import { RootState } from "@/store/types";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { getDefaultMonth } from "@/types";

export const state: ExecYearmonthState = {
  exec_yearmonth: getDefaultMonth().substr(0, 7),
  error: false
};

const namespaced = true;

export const exec_yearmonth: Module<ExecYearmonthState, RootState> = {
  namespaced,
  state,
  actions,
  mutations
};
